export default __webpack_public_path__ + "static/media/intern_fucking_has_a_good_time_and_nothing_bad_ever_happens.b832f9b3.png";